export default "__VITE_ASSET__BkUmzdvs__"